<template>
  <div class="container container_fluid content mb-5" v-html="content" />
</template>

<script>
export default {
  name: 'Privacy',
  computed: {
    content() {
      return window._content?.DETAIL_TEXT;
    }
  }
}
</script>

<style scoped lang="scss">

.content {
  font-size: 18px;
  font-family: EB Garamond;
  margin-top: 73px;

  @media screen and (max-width: 650px) {
    margin-top: 166px;
  }

  ::v-deep {

    & > div {
      margin-bottom: 3rem;
      margin-top: 3rem;
    }

    h5, h6 {
      font-weight: bold !important;
      font-size: 18px !important;
    }

    h5 {
      font-family: Gilroy;
      line-height: 22px !important;
    }

    h6 {
      line-height: 160% !important;
      margin-bottom: 16px !important;
    }

    .content a {
      color: #0500e5 !important;
      text-decoration: underline;
    }

    p {
      font-size: 18px;
      line-height: 160%;
      margin: 16px 0 !important;
    }

    ul {
      margin-top: 3rem !important;
      margin-bottom: 3rem !important;
    }

    .list li {
      padding-left: 10px;
      position: relative;
    }

    .list li::before {
      content: "";
      display: block;
      position: absolute;
      top: 12px;
      left: 0;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #000;
    }
  }
}
</style>
